import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import PDFViewer from "./PDFViewer";
import Logo from "./Logo";
import useOnLoad from "./useOnLoad";

const apiBaseUrl = "https://careergpt.herokuapp.com";
// const apiBaseUrl = "http://localhost:5000";
const ResumeForm = ({ accessToken }) => {
  const [file, setFile] = useState(null);
  const [result, setResult] = useState("");
  const [position, setPosition] = useState("");
  const [loading, setLoading] = useState(false);
  const [critique, setCritique] = useState('');
  const [selfIntro, setSelfIntro] = useState('');
  const [rewritedResume, setRewritedResume] = useState(""); // 新的状态变量
  const [activeButton, setActiveButton] = useState(1);
  const [error1, setError1] = useState("");
  const [notice, setNotice] = useState("");
  const [mockQ, setMockQ] = useState("");


  // const handleAnchorLoad = (ref) => {
  //   console.log(ref);
  //   if (ref.current) {
  //     document.getElementById("resumeBtn").click();
  //   }
  // };

  // const anchorRef = useOnLoad(handleAnchorLoad);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(accessToken.length!=64){
      setError1("Invalid access code")
      return
    }
    if (position.length > 30 || file == undefined) {
      setError1(`1. Desired Job max length is 30, but getting ${position.length}\n\n2. Making sure you upload your resume`);
      return;
    }

    setError1("");
    setLoading(true);
    setResult("\n");
    setNotice(`Please do not refresh page, it takes approx. 2mins`);

    try {
      mockClick("feedbackBtn");
      const formData = new FormData();
      formData.append("resume_pdf",file);
      formData.append("position",position);
      formData.append("token",accessToken);
      const response = await fetch(`${apiBaseUrl}/api/score_resume`,
        {
          method: 'POST',
          body: formData
        });
      
      
      const reader = response.body.getReader();
      const decoder = new TextDecoder('utf-8');
      const processStream = async (res) => {
        if(!res.done){
          setResult((prevResult)=> prevResult + decoder.decode(res.value));
          return reader.read().then(processStream);
        }else{
          setRewritedResume("\n");
          mockClick("resumeBtn");
          formData.append("feedback",result)
          const response1 = await fetch(`${apiBaseUrl}/api/rewrite_resume`,
          {
            method: 'POST',
            // headers: {
            //   "Content-Type": "multipart/form-data",
            // },
            body: formData
          });
          const reader1 = response1.body.getReader();
          const processStream1 = async (res) => {
            if(!res.done){
              setRewritedResume((prevResult)=> prevResult + decoder.decode(res.value));
              return reader1.read().then(processStream1);
            }else{
              setLoading(false);
              setNotice("");
            }
          };
          reader1.read().then(processStream1);
        }
      };
      reader.read().then(processStream);
      // setResult(response.data.score_and_critique); // 使用新的响应格式
      // setRewritedResume(response.data.rewrited_resume); // 设置重写后的简历文本

    } catch (error) {
      console.error(error);
      setError1(error.response.data);
      setLoading(false);
      setNotice("");

    }
  };

  const mockClick = (id) => {
    setTimeout(() => {
      console.log(document.getElementById(id));
      document.getElementById(id).click();
    }, 2000)
  }

  const handleDeepAnalyze = async () => {
    setLoading(true);
    setNotice(`Please do not refresh page, it takes approx. 2mins`);
    setCritique("\n");
    mockClick("reviewBtn");
    try {
      const formData = new FormData();
      formData.append("resume_text",rewritedResume);
      formData.append("position",position);
      formData.append("token",accessToken);
      const response = await fetch(`${apiBaseUrl}/api/deep_analyze`, {
        method: 'POST',
        body: formData
      });
    
    
    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    const processStream = async (res) => {
      if(!res.done){
        setCritique((prevResult)=> prevResult + decoder.decode(res.value));
        return reader.read().then(processStream);
      }else{
        setLoading(false);
        setNotice("");
      }
    }
    reader.read().then(processStream);
    } catch (error) {
      console.error(error);
      setError1(error.response.data);
      setLoading(false);
      setNotice("");
    }
  };

  const handleSelfIntro = async () => {
    setLoading(true);
    setNotice(`Please do not refresh page, it takes approx. 2mins`);
    setSelfIntro("\n");
    mockClick("introBtn");
    try {
      const formData = new FormData();
      formData.append("resume_text",rewritedResume);
      formData.append("position",position);
      formData.append("token",accessToken);
      const response = await fetch(`${apiBaseUrl}/api/self_intro`, {
        method: 'POST',
        body: formData
      });
    
    
    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    const processStream = async (res) => {
      if(!res.done){
        setSelfIntro((prevResult)=> prevResult + decoder.decode(res.value));
        return reader.read().then(processStream);
      }else{
        setLoading(false);
        setNotice("");
      }
    }
    reader.read().then(processStream);
    } catch (error) {
      console.error(error);
      setError1(error.response.data);
      setLoading(false);
      setNotice("");
    }
  };

  const handleMockQ = async () => {
    setLoading(true);
    setNotice(`Please do not refresh page, it takes approx. 2mins`);
    setMockQ("\n");
    mockClick("mockQBtn");
    try {
      const formData = new FormData();
      formData.append("resume_text",rewritedResume);
      formData.append("position",position);
      formData.append("token",accessToken);
      const response = await fetch(`${apiBaseUrl}/api/mock_q`, {
        method: 'POST',
        body: formData
      });
    
    
    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    const processStream = async (res) => {
      if(!res.done){
        setMockQ((prevResult)=> prevResult + decoder.decode(res.value));
        return reader.read().then(processStream);
      }else{
        setLoading(false);
        setNotice("");
      }
    }
    reader.read().then(processStream);
    } catch (error) {
      console.error(error);
      setError1(error.response.data);
      setLoading(false);
      setNotice("");
    }
  }

  return (

    <div className="lg:flex">
      <div className="flex-2 lg:max-w-xs lg:min-w-xs px-4 sm:px-6 lg:py-8 lg:px-8">
        <div className="h-full w-full flex flex-col">
          {error1 &&
            <div className="alert alert-error shadow-lg">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                <span><b>Error: </b><pre className="whitespace-pre-wrap break-words">{error1} </pre></span>
              </div>
            </div>
          }

          {notice &&
            <div>
              {loading && (
                <div className="mb-4 w-full flex justify-center">
                  <div className="spinner"></div>
                </div>
              )}
              <div className="alert alert-info shadow-lg">
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-current flex-shrink-0 w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                  <span><b>Note: </b><pre className="whitespace-pre-wrap break-words">{notice}</pre></span>
                </div>

              </div>
            </div>
          }
          <Logo />
          {!result && <div className="alert alert-warning shadow-lg w-auto">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-current flex-shrink-0 w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
              <span>Please upload your resume to unlock below features!</span>
            </div>
          </div>}
          <button className="rounded-xl border-2 border-black px-5 py-3 text-base mb-3 font-medium text-black-500 transform hover:translate-y-1 hover:shadow-lg transition-all duration-150 hover:bg-blue-600/5 active:bg-blue-900/5 disabled:from-gray-300 disabled:to-gray-400 disabled:text-gray-500 disabled:cursor-not-allowed" onClick={handleDeepAnalyze}
            disabled={(!result || loading)}
            title={!result ? "Please Submit Your Resume First!" : ""}>
            Deep Analyze
          </button>
          <button className="rounded-xl border-2 border-black px-5 py-3 text-base mb-3 font-medium text-black-500 transform hover:translate-y-1 hover:shadow-lg transition-all duration-150 hover:bg-blue-600/5 active:bg-blue-900/5 disabled:from-gray-300 disabled:to-gray-400 disabled:border-gray-500 disabled:text-gray-500 disabled:cursor-not-allowed" onClick={handleSelfIntro}
            disabled={(!result || loading)}
            title={!result ? "Please Submit Your Resume First!" : ""}>
            Generate Self-Intro
          </button>
          <button className="rounded-xl border-2 border-black px-5 py-3 text-base mb-3 font-medium text-black-500 transform hover:translate-y-1 hover:shadow-lg transition-all duration-150 hover:bg-blue-600/5 active:bg-blue-900/5 disabled:from-gray-300 disabled:to-gray-400 disabled:border-gray-500 disabled:text-gray-500 disabled:cursor-not-allowed" onClick={handleMockQ}
            disabled={(!result || loading)}
            title={!result ? "Please Submit Your Resume First!" : ""}>
            Mock Interview Q
          </button>
          <button className="rounded-xl border-2 border-black px-5 py-3 text-base mb-3 font-medium text-black-500 transform hover:translate-y-1 hover:shadow-lg transition-all duration-150 hover:bg-blue-600/5 active:bg-blue-900/5 disabled:from-gray-300 disabled:to-gray-400 disabled:border-gray-500 disabled:text-gray-500 disabled:cursor-not-allowed" disabled>
            More feature...
          </button>

        </div>
      </div>

      <div className="flex-1 max-w-7xl px-4 sm:px-6 lg:py-8 lg:px-8">
        <div>
          <div className="flex justify-begin py-2 gap-2 btn-group">

            <a href="#item1" onClick={() => setActiveButton(1)} className={activeButton === 1 ? 'btn btn-xs btn-active' : 'btn btn-xs '}>Upload</a>
            {(loading || result) &&
              <a href="#feedback" id="feedbackBtn" onClick={() => setActiveButton(2)} className={activeButton === 2 ? 'btn btn-xs btn-active' : 'btn btn-xs '}>Feedback</a>}
            {rewritedResume &&
              <a href="#resume" id="resumeBtn" onClick={() => setActiveButton(3)} className={activeButton === 3 ? 'btn btn-xs btn-active' : 'btn btn-xs '}>rewrited resume</a>}
            {critique &&
              <a href="#review" id="reviewBtn" onClick={() => setActiveButton(4)} className={activeButton === 4 ? 'btn btn-xs btn-active' : 'btn btn-xs '}>Further Review</a>}
            {selfIntro &&
              <a href="#intro" id='introBtn' onClick={() => setActiveButton(5)} className={activeButton === 5 ? 'btn btn-xs btn-active' : 'btn btn-xs '}>Self Intro</a>}
            {mockQ &&
              <a href="#mockQ" id='mockQBtn' onClick={() => setActiveButton(6)} className={activeButton === 6 ? 'btn btn-xs btn-active' : 'btn btn-xs '}>Mock Q</a>}
          </div>
        </div>
        <div className="carousel w-full h-full overflow-y-scroll max-h-480">
          <div id="item1" className="carousel-item w-full border">
            
            <div className="w-full h-full">
              <div className="mx-auto max-w-2xl">
                <div className="flex flex-col">
                  <div className="p-5 text-sm leading-6 text-gray-600">
                  <ol style={{listStyle:"decimal"}}>
                    <li>Enter access code - every service cost 1 token</li>
                    <li>Upload pdf resume and enter your desire job title</li>
                    <li>Hit Rewrite button to start review process</li>
                    <li>After rewrite success, you can access all feature on the left (Deep Analyze, Generate Self-intro, Generate Mock Interview Question)</li>
                  </ol>
                  </div>
                  <form onSubmit={handleSubmit} className="w-full max-w-md mx-auto" encType="multipart/form-data">
                    <div className="mt-2 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                      <div className="col-span-full">
                        <label htmlFor="position" className="block text-sm font-medium leading-6 text-gray-900">Desired Job:</label>
                        <div className="mt-2">
                          <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md">
                            <input
                              id="position"
                              value={position}
                              maxLength="30"
                              required
                              placeholder="  Your desired postion ..."
                              onChange={(e) => setPosition(e.target.value)}
                              className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-span-full mt-10">
                      <label htmlFor="resume" className="block text-sm font-medium leading-6 text-gray-900">Upload Resume (PDF)：</label>
                      <div className="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 px-6 py-10">
                        <div className="text-center">
                          {file && file.name}
                          {!file && (<svg className="mx-auto h-12 w-12 text-gray-300" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                            <path fillRule="evenodd" d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z" clipRule="evenodd" />
                          </svg>)}
                          {file && (<div ><PDFViewer file={file} /></div>)}

                          <div className="mt-4 flex text-sm leading-6 text-gray-600">

                            <label htmlFor="file-upload" className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500">
                              <span className="">Upload a file</span>
                              <input
                                id="file-upload"
                                type="file"
                                accept="application/pdf"
                                onChange={(e) => setFile(e.target.files[0])}
                                className="sr-only"
                                required
                              />
                            </label>
                            <p className="pl-1">or drag and drop</p>
                          </div>
                          <p className="text-xs leading-5 text-gray-600">PDF only</p>
                        </div>
                      </div>
                    </div>

                    <div className="col-span-full mt-2 flex justify-center">
                      <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        disabled={(loading)}
                      >
                        Rewrite
                      </button>
                    </div>
                  </form>

                </div>
              </div>


            </div>
          </div>
          {result &&
            <div id="feedback" className="carousel-item w-full overflow-y-scroll max-h-480">
              <pre className="whitespace-pre-wrap break-words">{result}</pre>

            </div>}
          {rewritedResume &&
            <div id="resume" className="carousel-item w-full overflow-y-scroll max-h-480">
              <pre className="whitespace-pre-wrap break-words">{rewritedResume}</pre>
            </div>}
          {critique &&
            <div id="review" className="carousel-item w-full overflow-y-scroll max-h-480">
              <pre className="whitespace-pre-wrap break-words">{critique}</pre>
            </div>}
          {selfIntro &&
            <div id='intro' className="carousel-item w-full overflow-y-scroll max-h-480">
              <pre className="whitespace-pre-wrap break-words">{selfIntro}</pre>
            </div>}
          {mockQ &&
            <div id='mockQ' className="carousel-item w-full overflow-y-scroll max-h-480">
              <pre className="whitespace-pre-wrap break-words">{mockQ}</pre>
            </div>}
        </div>

      </div>





    </div>


  );


};

export default ResumeForm;